angular.module('core')
  .service('highlightsApi', ['cancelableResourceFactory', 'transformResponse', '$q', function ($cancelableResourceFactory, $transformResponse, $q) {

    var DistrictHighlights = {
      get: function () {
        console.warn("District highlights api removed. Returning empty $q promise");
        var deferred = $q.defer();
        deferred.resolve({});
        return {
          $promise: deferred.promise
        };
      }
    };

    var StudentHighlights = $cancelableResourceFactory.createCacheableResource('StudentHighlights', '/r/districts/:districtId/highlights/students/:student_id', {id: '@id'}, {
      get: {
        url: '/r/districts/:districtId/students/:student_id/highlights',
        method: 'GET',
        isArray: false,
        transformResponse: $transformResponse.transformHighlights
      }
    });

    return {
      DistrictHighlights: DistrictHighlights,
      GradeHighlights: DistrictHighlights,
      SchoolHighlights: DistrictHighlights,
      TeacherHighlights: DistrictHighlights,
      ClassroomHighlights: DistrictHighlights,
      StudentHighlights: StudentHighlights
    };
}]);

